import React from 'react'
import './Header.css';
import { Avatar } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { useEffect } from "react";
import { useDataLayerValue } from './DataLayer';

const Header = () => {
    const [{ user }, dispatch] = useDataLayerValue();

    return (
        <div className='header'>
            <div className="header__left">
                <SearchIcon />
                <input type="text" placeholder="Search Songs, Artist, Albums" />
            </div>
            <div className="header__right">
                <Avatar src={user?.images[0].url} alt="SB" />
                <h4>{user?.display_name}</h4>
            </div>
        </div>
    )
}

export default Header